import {
    FETCH_CONTENTS_REQUESTED,
    FETCH_CONTENTS_SUCCESS,
    FETCH_CONTENTS_FAILURE,
    FETCH_CONTENTS_SEARCH_REQUESTED,
    FETCH_CONTENTS_SEARCH_SUCCESS,
    GENERATE_SRT_REQUESTED,
    GENERATE_SRT_SUCCESS,
    GENERATE_SRT_FAILURE,
    PING_SRT_REQUESTED,
    PING_SRT_SUCCESS,
    PING_SRT_FAILURE,
    TOGGLE_EDITOR_TITLE_SETTINGS_MODAL,
    SET_CURRENT_AUDIO_DURATION
} from "../actionTypes"

export const fetchContentsRequested = (data) => {
    return {
        type: FETCH_CONTENTS_REQUESTED,
        payload: data,
    };
};

export const fetchContentsSuccess = (data) => {
    return {
        type: FETCH_CONTENTS_SUCCESS,
        payload: data,
    };
};

export const fetchContentsFailure = (data) => {
    return {
        type: FETCH_CONTENTS_FAILURE,
        payload: data,
    };
};

export const fetchContentsSearchRequested = (data) => {
    return {
        type: FETCH_CONTENTS_SEARCH_REQUESTED,
        payload: data,
    };
};

export const fetchContentsSearchSuccess = (data) => {
    return {
        type: FETCH_CONTENTS_SEARCH_SUCCESS,
        payload: data,
    };
};

export const generateSRTRequested = (data) => {
    return {
        type : GENERATE_SRT_REQUESTED,
        payload : data
    }
}

export const generateSRTSuccess = (data) => {
    return {
        type : GENERATE_SRT_SUCCESS,
        payload : data
    }
}

export const generateSRTFailure = (data) => {
    return {
        type : GENERATE_SRT_FAILURE,
        payload : data
    }
}

export const pingSRTRequested = (data) => {
    return {
        type : PING_SRT_REQUESTED,
        payload : data
    }
}

export const pingSRTSuccess = (data) => {
    return {
        type : PING_SRT_SUCCESS,
        payload : data
    }
}

export const pingSRTFailure = (data) => {
    return {
        type : PING_SRT_FAILURE,
        payload : data
    }
}